import { render } from "./WidgetData.vue?vue&type=template&id=68841416&scoped=true"
import script from "./WidgetData.vue?vue&type=script&lang=js"
export * from "./WidgetData.vue?vue&type=script&lang=js"

import "./WidgetData.vue?vue&type=style&index=0&id=68841416&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68841416"]])

export default __exports__